import { InjectionToken } from '@angular/core';

export class InputMaskConfig {
  isAsync = false;
  inputSelector = 'input';
}
export const INPUT_MASK_CONFIG2 = new InjectionToken<InputMaskConfig>(
  'InputMaskConfig2'
);
